export default __webpack_public_path__ + "static/1372-1ef19185e5e6c1ccb51943019ff52762.gif";